import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PhotoInstructionInput = {
  id: string;
  instruction: string;
  isRequired: boolean;
};

export type UpdateLocationSalesPreferencesInput = {
  facilityId: string;
  defaultWeightDisplayUnit: string;
  defaultPort: string;
  enableDefaultPrinting: boolean;
  skipScalePayment: boolean;
  askForDeletionConfirmation: boolean;
  photoInstructions: PhotoInstructionInput[];
};

export const updateLocationSalesPreferencesMutationAtom =
  createMutationAtomFactory(
    'settings.updateLocationSalesPreferences',
    (input: UpdateLocationSalesPreferencesInput) => ({
      updateFacilitySalesPreferences: {
        __args: { input },
        defaultWeightDisplayUnit: true,
        defaultPort: true,
        enableDefaultPrinting: true,
        skipScalePayment: true,
        askForDeletionConfirmation: true,
        photoInstructions: {
          id: true,
          instruction: true,
          isRequired: true,
        },
      },
    }),
  );
